import styled from 'styled-components';

export const Container  = styled.div`
  max-height: 352px;
  overflow: auto;
  width: 100%;
`;
